import { Card } from "primereact/card";
import React, { useState } from "react";
import RadioButtonUI from "@UI/RadioButtonUI";
import UploadUI from "@UI/UploadUI";
import { inject, observer } from "mobx-react";

import "./style.scss";
import moment from "moment";

const dataRadioButton = [
    { label: "Нет", value: "not" },
    { label: "К нижнему регистру", value: "lowerCase" },
    { label: "К верхнему регистру", value: "upperCase" },
];

const UnloadPromo = inject("mainStore")(
    observer(({ mainStore }) => {
        const [data, setData] = useState("not");

        const handleUpload = async (e) => {
            const file = e.files?.[0];

            const formData = new FormData();
            formData.append("file", file);
            formData.append("typeRegistr", data);

            const resp = await mainStore.downloadFile(
                `/other/upload_activated_and_get_where`,
                formData,
                {
                    responseType: "blob",
                },
                `RIS_${moment().format("MMMM")}_активации.xlsx`,
            );
            e.options.clear();
        };

        return (
            <div className="unload-promo">
                <Card title={() => <span className="unload-promo__title">Выгрузка / {<span className="unload-promo__title_gray">Активированные промо</span>}</span>}>
                    <RadioButtonUI radioData={dataRadioButton} label="Привести данные к другому регистру?" value={data} onChange={(e) => setData(e.value)} />
                    <UploadUI handleUpload={handleUpload} />
                </Card>
            </div>
        );
    }),
);

export default UnloadPromo;
